import { useApplicantDetailsName } from '@gov-nx/core/hooks';
import type { ApplicantDetailsPersonsProps } from '@gov-nx/ui/types';

export const ApplicantDetailsName = ({
	individualPerson,
	businessPerson,
}: ApplicantDetailsPersonsProps) => {
	const applicantDetailsName = useApplicantDetailsName({
		individualPerson,
		businessPerson,
	});

	if (!applicantDetailsName) {
		return null;
	}

	return (
		<div>
			<dt className="text-body-s">{applicantDetailsName.label}</dt>
			<dd className="text-(--text-secondary)">{applicantDetailsName.name}</dd>
		</div>
	);
};
